import type { BookingListQuota, BookingResponse, Page } from '../api';

export const TripCardStatuses = { upcoming: 'upcoming', ongoing: 'ongoing' } as const;
export type TripCardStatus = typeof TripCardStatuses[keyof typeof TripCardStatuses];

/** Booking enriched with a client-computed time status (upcoming/ongoing), used by trip-card UI. */
export type BookingDto = BookingResponse & { timeStatus?: TripCardStatus };

export interface BookingListDto {
  content: BookingDto[];
  page: Page;
  quota?: BookingListQuota;
}
